export default "/images/8216ed4c25036ac3a6145de864abc869.avif";